module.exports = __webpack_public_path__ + "img/e3ed836.svg";